import { render, staticRenderFns } from "./VoucherDetailsSignatures.vue?vue&type=template&id=b0c99bf0&scoped=true"
import script from "./VoucherDetailsSignatures.vue?vue&type=script&lang=ts"
export * from "./VoucherDetailsSignatures.vue?vue&type=script&lang=ts"
import style0 from "./VoucherDetailsSignatures.vue?vue&type=style&index=0&id=b0c99bf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c99bf0",
  null
  
)

export default component.exports